/** @module csi/widget/_svg/ModeTextArea */
define([
	"dijit/form/ToggleButton",
	"./_Plugin",
	"./PluginFactory"
], function(ToggleButton,_Plugin,PluginFactory) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-toggle",
		iconClass: "csiActionIcon svgIconTextEditor",
		pluginName: "textArea",
		title: "CanvasText",
		tagShape: "text",

		/**
		 * Only show plugin for canvas when in edit mode
		 * @return {boolean}
		 */
		canShowPlugin: function() {
			return (!!this.editor.editMode);
		},

		/**
		 * Enable and disable the text mode
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (!this.editor.isDrawMode(this.tagShape) || (shapes && shapes.length)) {
				this.set('checked', false);
			}
			return true;
		},

		/**
		 * Invoke draw text shape action
		 */
		onClick: function() {
			// Reset the table metadata in case it was previously set.
			this.editor.setDrawMetadata(undefined);
			this.editor.setDrawMode('rect', true, true);
			this.set('checked', true);
		}
	});
});
